//JS pour le card contact
const buttons = document.querySelectorAll(".card-buttons button");
const sections = document.querySelectorAll(".card-section");
const card = document.querySelector(".card");
const handleButtonClick = (e)=>{
    const targetSection = e.target.getAttribute("data-section");
    const section = document.querySelector(targetSection);
    targetSection !== "#about" ? card.classList.add("is-active") : card.classList.remove("is-active");
    card.setAttribute("data-state", targetSection);
    sections.forEach((s)=>s.classList.remove("is-active"));
    buttons.forEach((b)=>b.classList.remove("is-active"));
    e.target.classList.add("is-active");
    section.classList.add("is-active");
};
buttons.forEach((btn)=>{
    btn.addEventListener("click", handleButtonClick);
});
//JS pour le form contacter-nous
document.getElementById('form').addEventListener('submit', async function(event) {
    event.preventDefault();
    //Executer reCAPTCHA
    const token = await grecaptcha.execute("6LeOXxAsAAAAALezJBx3XvUNB5VmW34pcJF68GxU", {
        action: 'submit'
    });
    const formData = new FormData(this);
    const data = {
        name: formData.get('name'),
        surname: formData.get('surname'),
        email: formData.get('email'),
        motif: formData.get('motif'),
        message: formData.get('message'),
        "g-recaptcha-response": token
    };
    try {
        const response = await fetch('/send-email', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        if (response.ok) {
            this.reset();
            var modal = document.getElementById("myModal");
            modal.style.display = "block";
        }
    } catch (error) {
        console.error('Erreur:', error);
        alert('Erreur lors de l\'envoi de l\'email');
    }
});
//Modal
// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[0];
// When the user clicks on <span> (x), close the modal
span.onclick = function() {
    var modal = document.getElementById("myModal");
    modal.style.display = "none";
};
// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
    var modal = document.getElementById("myModal");
    if (event.target == modal) modal.style.display = "none";
};

//# sourceMappingURL=sokapp.dev.41fa5742.js.map
